export default {
  'hotel': { hotel: 'common.hotel', room: { singular: 'common.hotelRoom', plural: 'common.hotelRooms' } },
  'glamping': { hotel: 'common.glamping', room: { singular: 'common.glampingRoom', plural: 'common.glampingRooms' } },
  'lodges': { hotel: 'common.lodges', room: { singular: 'common.lodgesRoom', plural: 'common.lodgesRooms' } },
  'treehouse': { hotel: 'common.treeHouse', room: { singular: 'common.treeHouse', plural: 'common.treeHouseRooms' } },
  'accommodation': { hotel: 'common.accommodation', room: { singular: 'common.accommodation', plural: 'common.accommodation' } }
}
